import { buildHeatShrinkFinishingLine } from './customHeatShrinkHelpers';

/**
 * Rows for Finishing summary: heat shrink per-end, custom text/logo extras, coding rings.
 * @param {object} [finishing]
 * @param {{ cartDefaultCodingRings?: boolean }} [options] cart line items always showed "Coding Rings: Black" when unset
 * @returns {Array<string>}
 */
export function buildFinishingDisplayRows(finishing, options = {}) {
  const rows = [];
  if (!finishing) {
    rows.push('None');
    return rows;
  }

  const hsLine = buildHeatShrinkFinishingLine(finishing);
  if (hsLine) {
    rows.push(hsLine);
  }

  if (finishing.codingRings) {
    if (typeof finishing.codingRings === 'string') {
      if (finishing.codingRings !== 'none') {
        rows.push(`Coding Rings: ${finishing.codingRings}`);
      }
    } else if (typeof finishing.codingRings === 'object') {
      const codingRingEntries = Object.entries(finishing.codingRings)
        .filter(([key, value]) => key !== 'global' && value && value !== 'none')
        .map(([key, value]) => `${key}: ${value}`);

      if (codingRingEntries.length > 0) {
        rows.push(`Coding Rings: ${codingRingEntries.join(', ')}`);
      } else if (finishing.codingRings.global && finishing.codingRings.global !== 'none') {
        rows.push(`Coding Rings: ${finishing.codingRings.global}`);
      }
    }
  }

  if (rows.length === 0) {
    rows.push('None');
  }

  if (
    options.cartDefaultCodingRings &&
    finishing &&
    !rows.some((r) => typeof r === 'string' && r.startsWith('Coding Rings'))
  ) {
    const idx = rows.indexOf('None');
    if (idx !== -1) rows.splice(idx, 1);
    rows.push('Coding Rings: Black');
    if (rows.length === 0) rows.push('None');
  }

  return rows;
}
